import React from 'react';

const AssetUploaderContext = React.createContext(undefined);

export default AssetUploaderContext;
